import React from 'react';

import { ClearVerifyStaffInviteManagersForm } from 'src/components/clearVerifyStaff';
import { Modal } from 'src/components/common';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export const ClearVerifyStaffInviteModalClearVerifyAdmin: React.FC = () => {
  const { closeModal, switchClosability, isOpen } = useModal(ModalId.ClearVerifyStaffInviteModal);

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Invite Clear Verify Staff"
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
    >
      <ClearVerifyStaffInviteManagersForm
        closeModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
